// extracted by mini-css-extract-plugin
export default {"multisignConfirmTxLink":"+3GfxciahD6u6EKdYPsuxA==","centerAlign":"aiGXvA4LvnutCoiePJuyqw==","sendBtnsWrapper":"Edwo5vTIcBZT6NJqYmt4zQ==","actionBtn":"zstQT5foYkP+sJVVusO1wg=="};